import { deleteProduct } from 'app/routes/Dashboard/actions/products';
import { Auth } from 'aws-amplify';
import { confirmBox, getError } from 'utils/appHelpers';

export const removeProductModal = (product, alert, t, onSuccess) => {
  const handleRemoveLikiee = async () => {
    try {
      await deleteProduct(product.id);
      if (onSuccess) await onSuccess(product);
      alert.success(t('msg_success_product_remove'));
    } catch (err) {
      alert.error(getError(err));
    }
  };

  const options = {
    onSuccess: handleRemoveLikiee,
    title: t('product_remove_title'),
    message: t('product_remove_text'),
    cancel: t('btn_cancel'),
    confirm: t('btn_confirm'),
  };
  confirmBox(options);
};

export const verifyEmailModal = (alert, t) => {
  const options = {
    onSuccess: () => {
      Auth.verifyCurrentUserAttribute('email');
      alert.success(t('verify_send_msg'));
    },
    title: t('verify_email_title'),
    message: t('verify_email_text'),
    confirm: t('btn_verify'),
  };
  confirmBox(options);
};
